// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k-pdf-export .k-pdf-info-item {
  gap: 8px;
}
.k-pdf-export .k-pdf-ticard-info-item {
  margin-right: 4px;
}
.k-pdf-export .k-pdf-hash-info-item .overflow-ellipsis {
  padding-right: 50px;
  overflow-wrap: anywhere !important;
  white-space: normal !important;
  overflow: visible !important;
}
.k-pdf-export .k-pdf-icon-right-margin {
  margin-right: 10px !important;
}
.k-pdf-export .k-pdf-classification-reason-icon-offset-top {
  margin-top: 1px !important;
}
.k-pdf-export .k-pdf-card-icon {
  margin-right: 20px;
}
.k-pdf-export .k-pdf-card-menu-spacing {
  gap: 1rem;
}
.k-pdf-export .k-pdf-hide-in-pdf {
  display: none;
}
.k-pdf-export .k-pdf-show-in-pdf {
  display: block !important;
}
.k-pdf-export .k-pdf-yara-matches-tooltip {
  margin-left: 1rem;
}
.k-pdf-export .k-pdf-rl-cloud-sandbox-analyze {
  margin-right: 4px;
}
.k-pdf-export .k-pdf-network-references-files-list {
  display: flex;
  flex-direction: column;
  max-height: 56px;
  row-gap: 2px;
}
.k-pdf-export .k-pdf-push-left {
  margin-left: -14px;
}
.k-pdf-export .k-pdf-email-box-right-margin {
  margin-right: 14px;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/containers/report_summary/report-summary-pdf.module.scss"],"names":[],"mappings":"AAEE;EACE,QAAA;AADJ;AAIE;EACE,iBAAA;AAFJ;AAMI;EACE,mBAAA;EACA,kCAAA;EACA,8BAAA;EACA,4BAAA;AAJN;AAQE;EACE,6BAAA;AANJ;AASE;EACE,0BAAA;AAPJ;AAUE;EACE,kBAAA;AARJ;AAWE;EACE,SAAA;AATJ;AAYE;EACE,aAAA;AAVJ;AAaE;EACE,yBAAA;AAXJ;AAcE;EACE,iBAAA;AAZJ;AAeE;EACE,iBAAA;AAbJ;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AAdJ;AAiBE;EACE,kBAAA;AAfJ;AAkBE;EACE,kBAAA;AAhBJ","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n:global(.k-pdf-export) {\n  :global(.k-pdf-info-item) {\n    gap: 8px;\n  }\n\n  :global(.k-pdf-ticard-info-item) {\n    margin-right: 4px;\n  }\n\n  :global(.k-pdf-hash-info-item) {\n    :global(.overflow-ellipsis) {\n      padding-right: 50px;\n      overflow-wrap: anywhere !important;\n      white-space: normal !important;\n      overflow: visible !important;\n    }\n  }\n\n  :global(.k-pdf-icon-right-margin) {\n    margin-right: 10px !important;\n  }\n\n  :global(.k-pdf-classification-reason-icon-offset-top) {\n    margin-top: 1px !important;\n  }\n\n  :global(.k-pdf-card-icon) {\n    margin-right: 20px;\n  }\n\n  :global(.k-pdf-card-menu-spacing) {\n    gap: 1rem;\n  }\n\n  :global(.k-pdf-hide-in-pdf) {\n    display: none;\n  }\n\n  :global(.k-pdf-show-in-pdf) {\n    display: block !important;\n  }\n\n  :global(.k-pdf-yara-matches-tooltip) {\n    margin-left: 1rem;\n  }\n\n  :global(.k-pdf-rl-cloud-sandbox-analyze) {\n    margin-right: 4px;\n  }\n\n  :global(.k-pdf-network-references-files-list) {\n    display: flex;\n    flex-direction: column;\n    max-height: 56px;\n    row-gap: 2px;\n  }\n\n  :global(.k-pdf-push-left) {\n    margin-left: -14px;\n  }\n\n  :global(.k-pdf-email-box-right-margin) {\n    margin-right: 14px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
